export const CALENDARIZE_ORIGIN = "https://calendarize.io"
export const CALENDARIZE_EMBED_JS_URL = "https://calendarize.io/embed/embed.js"

export function normalizeCalLink(url?: string | null): string | undefined {
  if (!url) return undefined
  return url.replace(`${CALENDARIZE_ORIGIN}/`, "")
}
